import * as types from "./types"
import http from "@/utils/http"

let state = {
  allLoad: false, // 加载完成
  isLoad: true, // 正在加载
  noData: false, // 暂无数据
  action: '',
  message: '',
  data: {},
  existMap: {},
  rechargeTotal: {}, // 充值汇总
  dataList:[],
  businessList:[],
  fixedPlateInfo: null,
  parkingLotConfig:{}
}
let actions = {
  [types.PRESENTPLATE] (context, params) {
    state.isLoad = true
    http.post('p-app-present-plate-query', params).then(data => {
    })
  },
  [types.PRESENTPLATEDELETE] (context, params) {
    http.post('p-app-present-plate-delete', params).then(data => {
      state.action = 'waiting'
    })
  },
  [types.BLACKLIST] (context, params) {
    state.isLoad = true
    http.post('p-app-black-list-query', params).then(data => {
    })
  },
  [types.DELETEBLACKLIST] (context, params) {
    http.post('p-app-black-list-delete', params).then(data => {
      state.action = 'waiting'
    })
  },
  [types.ADDBLACKLIST] (context, params) {
    http.post('p-app-black-list-add', params).then(data => {
      state.action = 'waiting'
    })
  },

  [types.CHARGETOTAL] (context, params) {
    state.isLoad = true
    http.post('p-app-charge-total-query', params).then(data => {
    })
  },
  [types.OPENGATERECORD] (context, params) {
    state.isLoad = true
    http.post('p-app-open-gate-record-query', params).then(data => {
    })
  },
  [types.PAYRECORD] (context, params) {
    state.isLoad = true
    http.post('p-app-pay-record-query', params).then(data => {
    })
  },
  [types.RECHARGERECORD] (context, params) {
    state.isLoad = true
    http.post('p-app-recharge-record-query', params).then(data => {
    })
  },
  [types.RECHARGERECORDTOTAL] (context, params) {
    state.isLoad = true
    http.post('p-app-recharge-total-query', params).then(data => {
    })
  },
  [types.UNPAIDRECORD] (context, params) {
    state.isLoad = true
    http.post('p-app-un-paid-record-query', params).then(data => {
    })
  },
  [types.FIXEDPLATE] (context, params) {
    state.isLoad = true
    http.post('p-app-fixed-plate-query', params).then(data => {
    })
  },
  [types.VEHICLEOWNERLIST] (context, params) {
    state.isLoad = true
    http.post('p-app-vehicle-owner-list-query', params).then(data => {
    })
  },
  [types.FIXEDPLATELIST] (context, params) {
    state.isLoad = true
    http.post('p-app-fixed-plate-list-query', params).then(data => {
    })
  },
  [types.FIXEDPLATEUPDATE] (context, params) {
    http.post('p-app-fixed-plate-update', params).then(data => {
      state.action = 'waiting'
    })
  },
  [types.FIXEDPLATEADD] (context, params) {
    http.post('p-app-fixed-plate-add', params).then(data => {
      state.action = 'waiting'
    })
  },
  [types.FIXEDPLATECHARGE] (context, params) {
    http.post('p-app-fixed-plate-charge', params).then(data => {
      state.action = 'waiting'
    })
  },
  [types.FIXEDPLATEDELETE] (context, params) {
    http.post('p-app-fixed-plate-delete', params).then(data => {
      state.action = 'waiting'
    })
  },
  [types.REPASSWORD] (context, params) {
    http.post('m-sys-user-changePwd', params).then(data => {
      state.data = data
    })
  },
  [types.BUSINESSQUERY] (context, params) {
    state.isLoad = true
    http.post('p-ypt-business-query', params).then(data => {
      mutations.setDataList(state,data.data.dataList)
    })
  },
  [types.BUSINESSSELECT] (context, params) {
    state.isLoad = true
    http.post('p-ypt-business-select', params).then(data => {
      state.businessList = data.data
    })
  },
  [types.BUSINESSUPDATE] (context, params) {
    state.action = 'waiting'
    http.post('p-ypt-business-update', params).then(data => {
      if(data && data.code === 'ok'){
        state.action = 'success'
      } else {
        state.action = 'error'
        state.message = data.message
      }
    })
  },
  [types.BUSINESSDELETE] (context, params) {
    state.action = 'waiting'
    http.post('p-ypt-business-delete', params).then(data => {
      if(data && data.code === 'ok'){
        state.action = 'delete'
      } else {
        state.action = 'error'
        state.message = data.message
      }
    })
  },
  [types.BUSINESSCHARGE] (context, params) {
    state.action = 'waiting'
    http.post('p-ypt-business-recharge', params).then(data => {
      if(data && data.code === 'ok'){
        state.action = 'recharge'
      } else {
        state.action =
        state.message = data.message
      }
    })
  },


  [types.COUPONSQUERY] (context, params) {
    state.isLoad = true
    http.post('p-ypt-business-coupons-query', params).then(data => {
      mutations.setDataList(state,data.data.dataList)
    })
  },
  [types.COUPONSUSEQUERY] (context, params) {
    state.isLoad = true
    http.post('p-app-coupons-use-query', params).then(data => {
      mutations.setDataList(state,data.data.dataList)
    })
  },
  [types.BUSINESSRECHARGEQUERY] (context, params) {
    state.isLoad = true
    http.post('p-app-business-recharge-query', params).then(data => {
      mutations.setDataList(state,data.data.dataList)
    })
  },
  [types.USERQUERY] (context, params) {
    state.isLoad = true
    http.post('p-app-user-query', params).then(data => {
      mutations.setDataList(state,data.data.dataList)
    })
  },
  [types.USERADD] (context, params) {
    state.action = 'waiting'
    http.post('m-sys-user-add', params).then(data => {
      if(data && data.code === 'ok'){
        state.action = 'success'
      } else {
        state.action = 'error'
        state.message = data.message
      }
    })
  },
  [types.USERUPDATE] (context, params) {
    state.action = 'waiting'
    http.post('m-sys-user-update', params).then(data => {
      if(data && data.code === 'ok'){
        state.action = 'success'
      } else {
        state.action = 'error'
        state.message = data.message
      }
    })
  },
  [types.USERDELETE] (context, params) {
    state.action = 'waiting'
    http.post('m-sys-user-delete', params).then(data => {
      if(data && data.code === 'ok'){
        state.action = 'delete'
      } else {
        state.action = 'error'
        state.message = data.message
      }
    })
  },

  [types.COUPONSUPDATE] (context, params) {
    state.action = 'waiting'
    http.post('p-ypt-business-coupons-update', params).then(data => {
      if(data && data.code === 'ok'){
        state.action = 'success'
      } else {
        state.action = 'error'
        state.message = data.message
      }
    })
  },
  [types.COUPONSADD] (context, params) {
    state.action = 'waiting'
    http.post('p-ypt-business-coupons-add', params).then(data => {
      if(data && data.code === 'ok'){
        state.action = 'success'
      } else {
        state.action = 'error'
        state.message = data.message
      }
    })
  },
  [types.COUPONSDELETE] (context, params) {
    state.action = 'waiting'
    http.post('p-ypt-business-coupons-delete', params).then(data => {
      if(data && data.code === 'ok'){
        state.action = 'delete'
      } else {
        state.action = 'error'
        state.message = data.message
      }
    })
  },
  [types.PARKINGLOTCONFIGQUERY] (context, params) {
    state.isLoad = true
    http.post('p-app-parking-lot-config-query', params).then(data => {
    })
  },
  [types.PARKINGLOTCONFIGUPDATE] (context, params) {
    state.action = 'waiting'
    http.post('p-app-parking-lot-config-update', params).then(data => {
      if(data && data.code === 'ok'){
        state.action = 'success'
      } else {
        state.action = 'error'
        state.message = data.message
      }
    })
  },
}
let mutations = {

  // 重置 临停 websocket数据
  resetDataList(state, data) {
    state.existMap ={}
    state.dataList = []
    state.isLoad = true
    state.allLoad = false
    state.noData= false
  },
  setDataList(state, data) {
    state.isLoad = false
    if(data.length>0){
      state.dataList = state.dataList.concat(data)
    } else {
      state.allLoad = true
    }
    if(state.dataList && state.dataList.length > 0){
    } else {
      state.noData= true
    }
  },

  setAction(state, data) {
    state.action = data
  },
  resetAction(state, data) {
    state.action = ''
  },

  setRechargeTotal(state, data) {
    state.rechargeTotal = data
  },
  setFixedPlateInfo(state, data) {
    state.fixedPlateInfo = data
  },
  resetFixedPlateInfo(state, data) {
    state.fixedPlateInfo = null
  },
  setParkingLotConfig(state, data) {
    state.parkingLotConfig = data
  }
}


export default { state, actions, mutations }



// WEBPACK FOOTER //
// ./src/store/app/mine/index.js